import React from 'react';
import { useFormContext } from 'react-hook-form';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import { getDisplayPerformanceFields } from 'containers/engagement/message/MessagePerformance';

function RecurringMessagePerformance({ data }) {
    const { getValues } = useFormContext() || {};
    const campaign = data || getValues() || {};
    if (!campaign?.recurringMessage) {
        return null
    }
    const message = campaign?.recurringMessage || {};
    return <MembershipInfoCard
        title={'PERFORMANCE'}
        data={message}
        fields={getDisplayPerformanceFields(message)}
    />
}

export default RecurringMessagePerformance